module.exports = __webpack_public_path__ + "images/emoji/fax.a7bb531e1254aba4453b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fax.png
// module id = Ty3a
// module chunks = 13